<template>
  <div class="home">
    <HeaderView />
    <section class="services">
      <div class="container">
        <h2>Cases</h2>
        <CaseCards />
      </div>
    </section>
    <AccordianView />
    <GetQoute/>
    <FooterView />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderView from "@/components/UiComponents/HeaderView.vue";
import CaseCards from "@/components/CaseCards.vue";
import AccordianView from "@/components/UiComponents/AccordianView.vue";
import FooterView from '@/components/UiComponents/FooterView.vue'
import GetQoute from "@/components/UiComponents/GetQoute.vue";

export default {
  name: 'CasesView',
  components: {
    HeaderView,
    CaseCards,
    AccordianView,
    GetQoute,
    FooterView,
  },
  methods: {}
}
</script>
